import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  connect() {
    this.tooltip = new Tooltip(this.element, { html: true })
  }

  disconnect() {
    if (!this.tooltip) return

    try {
      this.tooltip.dispose()
    } catch (_) {
      const tip = document.querySelector('.tooltip')
      if (tip) tip.remove()
    }

    this.tooltip = null
  }
}
